import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';

import {AppserviceService} from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as myGlobal from 'src/app/globals';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.sass']
})
export class TransactionsComponent implements OnInit {
  transTabledata=[];
  transFilterData = [];
  endAt = new Date();
  _date= new Date();
  fromTime = '';
  toTime = '';
  transForm:any;
  transModel = {
    'fromtime':'',
    'totime':''
  };
  transObj = {
    'from_time':'',
    'to_time':''
  }

  constructor(private _formBuilder: FormBuilder,public AppService:AppserviceService, private spinner:NgxSpinnerService) { }

  transactions(){
    var prevMonth,prevYear,
    days = this._date.getDate(),
    noofDays = new Date(this._date.getFullYear(), this._date.getMonth()+1, 0).getDate(),
    futureDay,
    futureMonth;

    if(days === noofDays){
      futureDay = '01';
      futureMonth = myGlobal.months[this._date.getMonth()+1];
    }else{
      futureDay = days + 1;
      futureMonth = myGlobal.months[this._date.getMonth()];
    }
    if((this._date.getMonth() - 1) < 0){
      prevMonth = 11;
      prevYear = this._date.getFullYear()-1;
    }else{
      prevMonth = this._date.getMonth() - 1;
      prevYear = this._date.getFullYear();
    } 

    this.transObj['to_time'] = futureDay + '-' + futureMonth +'-' + this._date.getFullYear().toString().slice(2,4);
    this.transObj['from_time'] = days + '-' + myGlobal.months[prevMonth] +'-' + prevYear.toString().slice(2,4);
    
    this.getTransData();
  }

  getTransData(){
    this.spinner.show();
    this.AppService.transactions(this.transObj).subscribe(
      (transData) => {
        this.spinner.hide();
        console.log(transData);
        this.transTabledata = this.transFilterData = transData['data'];
        this.AppService.setTransactionData(transData['data']);
      },
      (err) => { this.spinner.hide(); }
    );
  }

  searchTransTable(event){
    var _sV = event.target.value.toUpperCase();
      if(_sV.length === 1){
        this.transFilterData = Object.assign([], this.transTabledata).filter(item => {
          //if(event.target.value.length == 1){
            for(let key in item){
              //console.log(_sV, item[key].toString().charAt(0), item[key]);
              if((item[key] != null) && (_sV === item[key].toString().charAt(0))){
                return item;
              }
            }
        });
      }else{
        this.transFilterData = Object.assign([], this.transTabledata).filter(item => {
          //if(event.target.value.length == 1){
            for(let key in item){
              //console.log(key, (item[key] != null)?item[key]:'');
              if((item[key] != null) && item[key].toString().toUpperCase().indexOf(_sV) > -1){
                return item;
              }
            }
        });
      }
  }

  dateRange(event, target){
    var dateArray = event.value.toString().split(' ');
    if(target === 'from'){
      this.transObj['from_time'] = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[3].slice(2,4);
    }else if(target === 'to'){
      this.transObj['to_time'] = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[3].slice(2,4);
    }
    console.log(this.transObj);
    this.getTransData();
  }

  ngOnInit() {
    this.transForm = new FormGroup({
      'fromtime':new FormControl(this.transModel.fromtime),
      'totime':new FormControl(this.transModel.totime)
    });
    this.transTabledata = this.AppService.getTransactionData();
    console.log(this.transTabledata);
    this.transactions();
  }

}
